export const errorCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M8 0a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m-.857 4a.857.857 0 0 1 1.714 0v3.429a.857.857 0 0 1-1.714 0zM8 12.571a1.143 1.143 0 1 1 0-2.287 1.143 1.143 0 0 1 0 2.287"/></svg>`,
    name: 'error-circle'
};